// La fenêtre « Modifier mon profil ».
//
// Sortie de `views/profil.js`, dont la page est passée à React : l'y laisser
// obligeait le composant à importer le fichier qui l'importe — un cycle.
// Elle reste en HTML à dessein : une fenêtre s'ouvre, se remplit, se ferme.
// Elle n'a pas d'état qui vive dans le temps, donc rien à gagner à la traduire.
//
// Elle est appelée depuis deux endroits : le bouton « Modifier le profil » de la
// page, et l'écran Paramètres.
import Store from "../store.js";
import { esc, avatar, toast, modale } from "../ui.js";

export function editerProfil(ctx) {
  const u = ctx.moi;
  const { el, fermer } = modale({
    titre: "Modifier mon profil",
    corps: `
      <div class="edit-couverture" id="edit-couverture"${u.couverture ? ` style="background-image:url('${esc(u.couverture)}')"` : ""}>
        <label class="btn btn--fantome btn--petit">🖼️ Photo de couverture<input type="file" id="edit-couv-fichier" accept="image/*" hidden></label>
      </div>
      <div class="edit-photo">
        <span id="edit-avatar">${avatar(u, 84)}</span>
        <label class="btn btn--fantome btn--petit">Photo de profil<input type="file" id="edit-fichier" accept="image/*" hidden></label>
      </div>
      <label class="label">Nom complet<input class="champ" id="e-nom" maxlength="60" value="${esc(u.nom || "")}"></label>
      <label class="label">Église<input class="champ" id="e-eglise" maxlength="60" value="${esc(u.eglise || "")}" placeholder="Ex : ICC Parakou"></label>
      <label class="label">Ville<input class="champ" id="e-ville" maxlength="60" value="${esc(u.ville || "")}" placeholder="Ex : Parakou"></label>
      <label class="label">Bio<textarea class="champ" id="e-bio" rows="3" maxlength="300" placeholder="Quelques mots sur vous…">${esc(u.bio || "")}</textarea></label>`,
    actions: [
      { label: "Annuler" },
      {
        label: "Enregistrer",
        classe: "btn--primaire",
        onClick: async (fond, f) => {
          const nom = fond.querySelector("#e-nom").value.trim();
          if (!nom) return toast("Le nom est obligatoire", "erreur");
          const patch = {
            nom,
            eglise: fond.querySelector("#e-eglise").value.trim(),
            ville: fond.querySelector("#e-ville").value.trim(),
            bio: fond.querySelector("#e-bio").value.trim(),
          };
          if (photo !== null) patch.photo = photo;
          if (couverture !== null) patch.couverture = couverture;
          f();
          try {
            await Store.users.update(patch);
            ctx.majMoi(patch);
            toast("Profil mis à jour");
          } catch (e) {
            toast(e.message || "Enregistrement impossible", "erreur");
          }
        },
      },
    ],
  });

  let photo = null;
  let couverture = null;

  el.querySelector("#edit-fichier").addEventListener("change", async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    try {
      photo = await Store.upload(f, "image");
      el.querySelector("#edit-avatar").innerHTML = avatar({ nom: u.nom, photo }, 84);
    } catch (err) {
      toast(err.message || "Photo impossible à charger", "erreur");
    }
  });

  el.querySelector("#edit-couv-fichier").addEventListener("change", async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    try {
      couverture = await Store.upload(f, "image");
      el.querySelector("#edit-couverture").style.backgroundImage = `url('${couverture}')`;
    } catch (err) {
      toast(err.message || "Photo impossible à charger", "erreur");
    }
  });
  return fermer;
}
